// extracted by mini-css-extract-plugin
module.exports = {"footerModalRoot":"index-footerModalRoot-1XL5M","footerRoot":"index-footerRoot-HHdaS","showFooter":"index-showFooter-1KQDF"};